import { render, staticRenderFns } from "./IconLoading.vue?vue&type=template&id=7c298e2c&scoped=true&lang=pug&"
import script from "./IconLoading.vue?vue&type=script&lang=ts&"
export * from "./IconLoading.vue?vue&type=script&lang=ts&"
import style0 from "./IconLoading.vue?vue&type=style&index=0&id=7c298e2c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c298e2c",
  null
  
)

export default component.exports